let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("26UTw")).then(() => parcelRequire('13yNJ'));